import { render, staticRenderFns } from "./PromotionDuplicatedNotice.vue?vue&type=template&id=5dbe89d7&scoped=true&"
import script from "./PromotionDuplicatedNotice.vue?vue&type=script&lang=js&"
export * from "./PromotionDuplicatedNotice.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDuplicatedNotice.vue?vue&type=style&index=0&id=5dbe89d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbe89d7",
  null
  
)

export default component.exports